import React, {Component} from "react";
import { strings } from "../localization";
import { TAG_TYPES } from "../data/tags";
import { TagBadge } from "./TagsList";
import CustomDropDown from "./CustomDropDown";

export default class TagTypesDropDown extends Component{
    
    constructor(props){
        super(props);

        this.getOptions = this.getOptions.bind(this);

        this.options = this.getOptions();
    }

    getOptions = () => {
        const options = [];
        const includeSystemType = this.props.includeSystemType ? this.props.includeSystemType : false;

        if(this.props.showOptionForAll){
            options.push({
                value: "",
                label: <><TagBadge tagType={strings.tags_type_all_label} /><span>{strings.tags_type_all_label}</span></>,
            });
        }

        for(let type in TAG_TYPES){
            const label = strings[`tags_type_${TAG_TYPES[type].toLowerCase()}_label`];

            if(type === TAG_TYPES.SYSTEM){
                if(includeSystemType){
                    options.push({
                        value: type,
                        label: <><TagBadge tagType={type} /><span>{label}</span></>,
                    });
                }
                else continue;
            }else{
                options.push({
                    value: type,
                    label: <><TagBadge tagType={type} /><span>{label}</span></>,
                });
            }
        }

        return options
    }

    render(){
        let {className, selectedItems, ...rest} = this.props;
        // RAV-6242
        // Without a related patch in TagsTreeView (see its code comment for RAV-6242),
        // the selectedItems prop may contain TAG_TYPES.SYSTEM which might be omitted in the options list.
        if (selectedItems === TAG_TYPES.SYSTEM) {
            // check if this.options contains TAG_TYPES.SYSTEM
            const systemTypeOption = this.options.find(option => option.value === TAG_TYPES.SYSTEM);

            // if not found, sanitize the issue by selecting a default
            if (!systemTypeOption) {

                // choose TAG_TYPES.EQUIPMENT as default if it exists
                const defaultOption = this.options.find(option => option.value === TAG_TYPES.EQUIPMENT);
                if (defaultOption) {
                    selectedItems = [defaultOption.value];
                } else {
                    // choose the first option if TAG_TYPES.EQUIPMENT does not exist
                    selectedItems = [this.options[0].value];
                }
                console.warn("TagTypesDropDown: Selected `SYSTEM` item not found in options list.  Using " + selectedItems[0] + " as default.");
            }
        }
        return (
            <CustomDropDown
                className={`tag-types-dropdown ${className}`}
                items={this.options}
                placeholder={strings.tags_type_all_label}
                selectedItems={selectedItems}
                {...rest}
            />);
    }
   
}